var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloperDocs(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.448 1.888h-.001a.57.57 0 00-.57.573v8.585c0 .315.257.572.573.573 1.333.003 3.566.28 5.106 1.893V4.527a.549.549 0 00-.079-.29C6.213 2.2 3.784 1.89 2.448 1.888zM14.123 11.046V2.461a.57.57 0 00-.57-.573c-1.336.003-3.766.313-5.03 2.349a.549.549 0 00-.079.29v8.984c1.54-1.612 3.773-1.89 5.106-1.893a.574.574 0 00.573-.572z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.428 3.868h-.415v7.178c0 .804-.655 1.46-1.46 1.461-1.13.003-2.995.224-4.315 1.473 2.283-.559 4.69-.195 6.062.117a.571.571 0 00.7-.557v-9.1a.573.573 0 00-.572-.572zM.988 11.046V3.868H.572A.573.573 0 000 4.441v9.099a.57.57 0 00.7.557c1.372-.312 3.779-.676 6.062-.117-1.32-1.249-3.184-1.47-4.314-1.473a1.465 1.465 0 01-1.46-1.46z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperDocs);
export default "/_next/static/images/ec21cb5f52506d405b5055c0ab808a23.svg";
export { ForwardRef as ReactComponent };